import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api';
import { UserRole } from 'models/UserRole';

export const RoleActionType = {
    FETCH_ROLES: 'FETCH_ROLES',
    FETCH_ROLES_SUCCESS: 'FETCH_ROLES_SUCCESS',
    API_ERROR: 'API_ERROR',
};


interface IFetchRolesAction {
    type: typeof RoleActionType.FETCH_ROLES
    payload: ApiPayload,
    returnPayload: UserRole[],
    meta: {
        isApiCall: boolean
    },
}

export type IRoleActions = IFetchRolesAction;

export class RoleActions {
    public static fetchRoles(token: string): IRoleActions {
        return {
            type: RoleActionType.FETCH_ROLES,
            payload: Api.fetchApiCall('api/UserData/Roles', token, RoleActionType.FETCH_ROLES_SUCCESS, RoleActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }
}

